
import { useState, useEffect } from 'react';
import { Session, User } from '@supabase/supabase-js';
import { supabase } from '@/integrations/supabase/client';
import { useNavigate, useLocation } from 'react-router-dom';
import { handleAuthRedirect } from './authUtils';

export const useAuthEffect = () => {
  const [session, setSession] = useState<Session | null>(null);
  const [user, setUser] = useState<User | null>(null);
  const [loading, setLoading] = useState(true);
  const navigate = useNavigate();
  const location = useLocation();

  useEffect(() => {
    console.log('Auth provider initialized, current location:', location.pathname, 'hash:', location.hash);
    
    // Handle hash fragment with auth tokens first if present
    handleAuthRedirect(
      location.hash,
      location.pathname,
      setLoading,
      setSession,
      setUser,
      navigate
    );

    // Set up auth state listener
    const { data: { subscription } } = supabase.auth.onAuthStateChange((event, session) => {
      console.log('Auth state changed:', event, session?.user?.email);
      setSession(session);
      setUser(session?.user ?? null);

      if (event === 'SIGNED_OUT') {
        navigate('/auth');
      } else if ((event === 'SIGNED_IN' || event === 'TOKEN_REFRESHED') && location.pathname === '/auth') {
        // Only redirect to teams if we're on the auth page
        navigate('/teams');
      }
    });

    return () => {
      subscription.unsubscribe();
    };
  }, [navigate, location]);

  return { session, user, loading, setSession, setUser, setLoading };
};
